<template>
  <mj-modal-wrapper>
    <mj-modal-head>
      <h2 class="font-semibold text-white text-2xl">
        Profil bearbeiten
      </h2>
    </mj-modal-head>

    <mj-modal-content>
      <mj-validation-observer
        id="profile-edit"
        ref="formObserver"
        v-slot="{ invalid }"
        tag="form"
        method="post"
        @submit.prevent="onSubmit"
      >
        <div class="profile-edit-modal__inputs">
          <mj-input-group>
            <mj-input-label
              for="name"
              class="text-lg text-gray-900"
            >
              Dein Name
            </mj-input-label>
            <mj-validation-input-field
              v-model="profileForm.name"
              name="name"
              placeholder="Dein Name"
              autocomplete="off"
              rules="required"
            />
          </mj-input-group>

          <mj-input-group>
            <mj-input-label
              for="email"
              class="text-lg text-gray-900"
            >
              Deine E-Mail
            </mj-input-label>
            <mj-validation-input-field
              v-model="profileForm.email"
              name="email"
              placeholder="deine.email@woauchimmer.de"
              autocomplete="off"
              rules="required|email"
            />
          </mj-input-group>
        </div>
        <div class="profile-edit-modal__buttons flex justify-between mt-12">
          <div class="close">
            <mj-button
              class="btn-naked"
              @click="onClose"
            >
              Abbrechen
            </mj-button>
          </div>
          <div class="submit">
            <mj-button
              class="btn-primary inline-flex"
              :is-busy="isBusy"
              :disabled="invalid"
              type="submit"
              @click="onSubmit"
            >
              Speichern
            </mj-button>
          </div>
        </div>
      </mj-validation-observer>
    </mj-modal-content>
  </mj-modal-wrapper>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalWrapper from '@/components/ui/general/modal/ModalWrapper.vue';
import ModalHead from '@/components/ui/general/modal/ModalHead.vue';
import ModalContent from '@/components/ui/general/modal/ModalContent.vue';

export default {

  name: 'ProfileEditModal',

  components: {
    'mj-modal-wrapper': ModalWrapper,
    'mj-modal-head': ModalHead,
    'mj-modal-content': ModalContent,
  },

  props: {
    params: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      profileForm: {
        name: '',
        email: '',
      },
      isBusy: false,
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    ...mapActions(['updateUser']),

    async onSubmit() {
      if (await this.$refs.formObserver.validate()) {
        this.isBusy = true;
        this.updateUser(this.profileForm)
          .then(() => {
            this.onClose();
          })
          .catch(({ response }) => {
            this.$refs.formObserver.setErrors(response.data.errors);
          })
          .finally(() => { this.isBusy = false; });
      }
    },

    onClose() {
      this.$modal.hide('root-modal');
    },
  },

  created() {
    this.profileForm.name = this.user.name;
    this.profileForm.email = this.user.email;
  },
};
</script>
